import { GraphQLClient } from 'graphql-request';
import { CONTENTSTACK_GRAPHQL_ENDPOINT } from '../../env';

export const graphQLClient = new GraphQLClient(CONTENTSTACK_GRAPHQL_ENDPOINT, {
  headers: {
    host: 'graphql.contentstack.com',
    access_token: process.env.CONTENTSTACK_LEARN_DELIVERY_TOKEN,
  },
});

export * from './author';
export * from './core';
export * from './page-glossary';
export * from './page/main/header-and-footer';
export * from './page/main/homepage';
